import { Component } from '@angular/core';
import { AuthService } from '../../auth.service';
import { Router } from '@angular/router';


@Component({
    selector: 'app-header',
    imports: [
],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {

  constructor(private auth: AuthService, private router: Router) { }


  getLocalMenu(): string {
    let navMenu = `<ul id="siteMenu">
      <li><a href="/" title="Need Assistance">Need Assistance</a>
        <ul>
          <li><a href="/questionnaire" title="VITA questionnaire">Can VITA help you?</a></li>
          <li><a href="/signup" title="Signup for an Appointment">Sign Up for a VITA Appointment</a></li>
          <li><a href="/appointment/cancel" title="Cancel/Reschedule an Appointment">Cancel/Reschedule an Appointment</a></li>
          <li><a href="/self_assist" title="Facilitated Self-Assistance (FSA)">Facilitated Self-Assistance (FSA)</a></li>
        </ul>
      </li>`

    navMenu += `<li><a href="/volunteer" title="Volunteer">Staff</a>
    <ul>`

    if (this.isAuthenticated()) {
      navMenu += `<li><a id="logout" href="#">Logout</a></li>
        <li><a href="/profile">Profile</a></li>`
    } else {
      navMenu += `<li><a href="/login">Login</a></li>`
    }
    navMenu += `</ul></li>`

    if (this.isAuthenticated()) {
      navMenu += `<li><a href="/queue" title="Queue">Queue</a></li>
      <li><a href="/management" title="Management Tools">Management</a>
        <ul>
          <li><a href="/management/appointments" title="Appointment Management">Appointment Management</a></li>
          `
      if (this.auth.canDo('Use Admin Tools')) {
        navMenu += `
          <li><a href="/management/users" title="User Management">User Management</a></li>
          <li><a href="/management/sites" title="Site Management">Site Management</a></li>
          <li><a href="/overbookings" title="Overbookings">Overbookings</a></li>
          <li><a href="/management/duplicates" title="Overbookings">Duplicate Signups</a></li>
          <li><a href="/management/demographics" title="Overbookings">Demographics</a></li>`
          // <li><a href="/management/documents" title="Print Documents">Print Documents</a></li>
          // <li><a href="/management/analytics" title="Analytics">Analytics</a></li>`
      }
      navMenu += `
        </ul>
      </li>`
    }
    return navMenu
  }

  updateMenu() {
    $('#siteMenu').replaceWith(this.getLocalMenu());
    this.updateNav();
  }

  ngOnInit() {

    this.auth.getAuthenticatedObservable().subscribe(_ => {
      this.updateMenu()
    })
    this.updateNav()
  }
  updateNav() {
    const component = this
    $(() => {
      $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/header-global-1.html", (data1) => {
        $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/header-global-2.html", (data2) => {
          $("#header1").replaceWith(data1 + '<div id="nav1"></div><div id="nav2"></div><div id="search"></div>' + data2)
          $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/nav-global-1.html", (data1) => {
            $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/nav-global-2.html", (data2) => {
              $("#nav1").replaceWith(data1 + '<div id="visit1"></div><div id="apply1"></div><div id="give1"></div>' + data2)
              $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/visit-global-1.html", (data1) => {
                $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/visit-global-2.html", (data2) => {
                  $("#visit1").replaceWith(data1 + '<div id="visitLocal"></div>' + data2)
                  $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/local/visit-local.html", (data) => {
                    $("#visitLocal").replaceWith(data); 
                  }) 
                }) 
              }) 
              $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/apply-global-1.html", (data1) => {
                $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/apply-global-2.html", (data2) => {
                  $("#apply1").replaceWith(data1 + '<div id="applyLocal"></div>' + data2)
                  $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/local/apply-local.html", (data) => {
                    $("#applyLocal").replaceWith(data); 
                  }) 
                }) 
              }) 
              $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/give-global-1.html", (data1) => {
                $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/give-global-2.html", (data2) => {
                  $("#give1").replaceWith(data1 + `<div id="giveLocal"></div>` + data2)
                  $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/local/give-local.html", (data) => {
                    $("#giveLocal").replaceWith(data); 
                  }) 
                }) 
              }) 
            }) 
          }) 
          $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/search.html", (data) => {
            $("#search").replaceWith(data); 
          }) 
        }) 
      })
      $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/logo-lockup-1.html", (data1) => {
        $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/logo-lockup-2.html", (data2) => {
          $("#logo1").replaceWith(data1 + '<div id="site1"></div><div id="siteTitle1"></div>' + data2)
          $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/site-affiliation-1.html", (data1) => {
            $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/site-affiliation-2.html", (data2) => {
              $("#site1").replaceWith(data1 + data2)
            }) 
          }) 
          $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/site-title-1.html", (data1) => {
            $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/site-title-2.html", (data2) => {
              $("#siteTitle1").replaceWith(data1 + '<a class="unl-site-title-medium" href="/">TCAN / VITA Lincoln</a>' + data2)
            }) 
          }) 
        }) 
      })
      $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/nav-toggle-group.html", (data) => {
        $("#navGroup").replaceWith(data); 
      }) 
      $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/nav-menu-1.html", (data1) => {
        $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/nav-menu-2.html", (data2) => {
          $("#navMenu1").replaceWith(data1 + '<div id="navBtn"></div><div id="navMenuChild1"></div>' + data2)
          $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/nav-toggle-btn.html", (data) => {
            $("#navBtn").replaceWith(data); 
          }) 
          $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/nav-menu-child-1.html", (data1) => {
            $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/nav-menu-child-2.html", (data2) => {
              $("#navMenuChild1").replaceWith(data1 + '<div id="theMenu"></div>' + data2)
              $('#theMenu').replaceWith(component.getLocalMenu());
              $('#logout').on('click', (e) => {
                component.onLogout()
              })
                $(() => {
                $.get("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/js-body.html", (data) => {
                  $("#includedContent").replaceWith(data); 
            
                })
              })
            }) 
          }) 
        }) 
      }) 
    })
  }
  isAuthenticated(): boolean {
    return this.auth.isAuthenticated()
  }

  onLogout() {
    this.auth.onLogout()
    this.router.navigate(['/'])
  }
}